import {
  BOOTSTRAP,
  SUGGESTED_ARTICLES,
  LOAD_HOLIDAYS,
  BootstrapActionPayload,
} from './actions';
import { Article } from '../../../models/article';
import createReducer from '../../../lib/createReducer';
import { Brand } from '../../../lib/theme';
import { Holiday } from '../../HolidayCheckout/store/selectors';

export interface ArticleState {
  brand: Brand;
  article: Article;
  destinationIds: number[];
  suggestedArticlesUrl?: string;
  suggestedArticles: Article[];
  holidays: Holiday[];
  holidaysUrl?: string;
  adConfig: {
    layout: string;
    units: {
      [key: string]: string;
    };
  };
  socialMedia: {
    twitter: string;
    facebook: string;
    site: string;
    fb_id: string;
  };
  faviconUrl: string;
  hideAds: boolean;
  hideComments: boolean;
  hideStickyRecirc: boolean;
  showLinkbyPubFeed: boolean;
  advertiserBuyoutExpiration?: string;
}

const initialState = {
  brand: 'tas',
  article: {},
  suggestedArticles: [],
  holidays: [],
  adConfig: {
    layout: 'standard',
    units: {},
  },
  socialMedia: {},
  hideAds: false,
  hideComments: false,
  hideStickyRecirc: false,
  showLinkbyPubFeed: false,
};

const handleBootstrap = (
  state: ArticleState,
  {
    brand,
    article,
    adConfig,
    socialMedia,
    destinationIds,
    suggestedArticles = [],
    suggestedArticlesUrl,
    holidaysUrl,
    hideAds,
    hideComments,
    hideStickyRecirc,
    showLinkbyPubFeed,
  }: BootstrapActionPayload
): ArticleState => ({
  ...state,
  brand,
  article,
  adConfig,
  destinationIds,
  socialMedia,
  suggestedArticles,
  suggestedArticlesUrl,
  holidaysUrl,
  hideAds: !!hideAds,
  hideComments: !!hideComments,
  hideStickyRecirc: !!hideStickyRecirc,
  showLinkbyPubFeed: !!showLinkbyPubFeed,
});

const handleSuggestedArticles = (
  state: ArticleState,
  articles: Article[]
): ArticleState => ({
  ...state,
  suggestedArticles: articles,
});

const handleLoadHolidays = (
  state: ArticleState,
  holidays: Holiday[]
): ArticleState => ({
  ...state,
  holidays,
});

const handlers = {
  [BOOTSTRAP]: handleBootstrap,
  [`${SUGGESTED_ARTICLES}_FULFILLED`]: handleSuggestedArticles,
  [`${LOAD_HOLIDAYS}_FULFILLED`]: handleLoadHolidays,
};

export default createReducer(handlers, initialState);
